import React, { useState } from 'react';
import {
  ArrowLeft,
  GraduationCap,
  LogIn,
  ShieldCheck,
  Wrench,
} from 'lucide-react';
import './LoginUnificado.css';
import { API_ENDPOINTS } from '../config/api';

const LoginUnificado = ({ onLoginAdmin, onLoginProfesor }) => {
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [rol, setRol] = useState(''); // '' | 'admin' | 'profesor'
  const [mensaje, setMensaje] = useState('');

  const manejarLogin = async (e) => {
    e.preventDefault();

    const url =
      rol === 'admin'
        ? API_ENDPOINTS.loginAdmin
        : API_ENDPOINTS.loginProfesor;

    try {
      const respuesta = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, contrasena }),
      });

      const resultado = await respuesta.json();

      if (respuesta.ok) {
        setMensaje('');

        if (rol === 'admin') {
          localStorage.setItem('adminLogueado', 'true');
          localStorage.setItem('rolAdmin', resultado.administrador.rol);
          localStorage.setItem('adminId', resultado.administrador.id);
          onLoginAdmin();
        } else {
          localStorage.setItem('profesorId', resultado.profesor.id);
          localStorage.setItem('profesorNombre', resultado.profesor.nombre);
          localStorage.setItem('profesorArea', resultado.profesor.area);
          onLoginProfesor();
        }
      } else {
        setMensaje(resultado?.mensaje || 'Credenciales incorrectas');
      }
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      setMensaje('Error de conexión');
    }
  };

  const volverRol = () => {
    setRol('');
    setMensaje('');
    setUsuario('');
    setContrasena('');
  };

  const esAdmin = rol === 'admin';

  return (
    <div className="login-fondo">
      <div className="login-card">
        <div className="login-header">
          <div className="login-brand">
            <div className="login-logo">FB</div>
            <div>
              <div className="login-estado">
                <span className="login-estado-punto" />
                Pedidos y soporte escolar
              </div>
              <h1 className="login-titulo">FBDesk</h1>
            </div>
          </div>

          <div className="login-header-info">
            <p className="login-subtitulo">
              Soporte, inventario y seguimiento de pedidos
            </p>

            {rol && (
              <button type="button" className="login-btn-sec" onClick={volverRol}>
                <ArrowLeft size={16} />
                Cambiar acceso
              </button>
            )}
          </div>
        </div>

        <div className="login-body">
          {!rol ? (
            <div className="login-selector">
              <div className="login-intro">
                <span className="login-kicker">Ingreso al sistema</span>
                <h2 className="login-h2">Elegí cómo vas a ingresar</h2>
              </div>

              <div className="login-grid">
                <button type="button" className="login-opcion" onClick={() => setRol('profesor')}>
                  <span className="login-opcion-icono">
                    <GraduationCap size={26} />
                  </span>
                  <h3 className="login-opcion-titulo">Acceso Docente</h3>
                  <p className="login-opcion-texto">
                    Cargar pedidos y ver solicitudes.
                  </p>
                  <span className="login-opcion-detalle">
                    Nuevo pedido · Mis pedidos
                  </span>
                </button>

                <button type="button" className="login-opcion" onClick={() => setRol('admin')}>
                  <span className="login-opcion-icono">
                    <ShieldCheck size={26} />
                  </span>
                  <h3 className="login-opcion-titulo">
                    Acceso Soporte
                  </h3>
                  <p className="login-opcion-texto">
                    Gestionar pedidos, salas e inventario.
                  </p>
                  <span className="login-opcion-detalle">
                    Administrador · Técnico
                  </span>
                </button>
              </div>
            </div>
          ) : (
            <div className="login-form-layout">
              <aside className="login-form-panel">
                <span className="login-opcion-icono login-opcion-icono-grande">
                  {esAdmin ? <Wrench size={30} /> : <GraduationCap size={30} />}
                </span>
                <span className="login-kicker">Acceso seleccionado</span>
                <h2 className="login-h2">
                  {esAdmin ? 'Administración y soporte' : 'Docente'}
                </h2>
                <p className="login-p">
                  {esAdmin
                    ? 'Pedidos, salas, equipos e inventario.'
                    : 'Pedidos nuevos y seguimiento.'}
                </p>
              </aside>

              <div className="login-form-area">
                <h2 className="login-h2 login-form-title">Iniciar sesión</h2>

                <form onSubmit={manejarLogin}>
                  <div className="login-fila">
                    <label className="login-campo">
                      <span>Usuario</span>
                      <input
                        className="login-input"
                        type="text"
                        placeholder="Usuario"
                        value={usuario}
                        onChange={(e) => setUsuario(e.target.value)}
                        required
                        autoFocus
                      />
                    </label>

                    <label className="login-campo">
                      <span>Contraseña</span>
                      <input
                        className="login-input"
                        type="password"
                        placeholder="Contraseña"
                        value={contrasena}
                        onChange={(e) => setContrasena(e.target.value)}
                        required
                      />
                    </label>
                  </div>

                  <button className="login-btn" type="submit">
                    <LogIn size={18} />
                    Iniciar sesión
                  </button>

                  {mensaje && <div className="login-alerta">{mensaje}</div>}
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginUnificado;
